import { useIssueId } from '@atlassian/jira-issue-context-service/src/main.tsx';
import { createAri, type Ari } from '@atlassian/jira-platform-ari/src/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';

/**
 * There is a important pitfall to be validated when using this hook.
 * When transitioning to an issue which was already loaded previously, the issue-context-store takes time to sync the correct issueID from issue-store.
 * Until that happens any component that is using this hook will get incorrect issueARI(either null or incorrect).
 * To ensure this does not lead to a bug, ensure that the issueARI value being referenced is ALWAYS the latest and the correct reference is being used.
 * @returns the ARI for the current issue
 * @example ari:cloud:jira:49d8b9d6-ee7d-4931-a0ca-7fcae7d1c3b5:issue/681276
 */
export const useIssueAri = (): Ari => {
	const cloudId = useCloudId();
	const issueId = useIssueId();
	return createAri({
		resourceOwner: 'jira',
		cloudId,
		resourceType: 'issue',
		resourceId: issueId ?? '',
	});
};
